export default __webpack_public_path__ + "static/logo-full-7a37575e00d3baaa0621477c3188dbf0.svg";